import { Box, IconButton, makeStyles, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
import React from 'react';
import CloseIcon from '../atoms/icons/CloseIcon';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  mobileHeader: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: '36px'
    }
  },
  closeButton: {
    borderRadius: '12px',
    backgroundColor: '#EBECF1',
    padding: '12px'
  },
}));

export default function HeaderDetailsMobile({ closeDrawer }) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Box className={classes.mobileHeader}>
      <Typography variant={'h4'} component="p" >
        Detalhes
      </Typography>
      <IconButton className={classes.closeButton} onClick={() => closeDrawer(false)}>
        <CloseIcon color={theme.palette.gray.main} />
      </IconButton>
    </Box>
  );
}

HeaderDetailsMobile.propTypes = {
  closeDrawer: PropTypes.func.isRequired
};
